<template>
    <div v-if="this.buttons" class="btn-group col-12 col-md-6 mb-3" role="group" aria-label="">
        <Button v-for="s in stages" :key="s.stage"
            :name="s.name"
            v-on:click="this.updateStage(s.stage)"
            :type='s.stage == this.stage ? "btn-success" : "btn-outline-success"'/>
    </div>
    <!-- Auth redesign — степпер dot/line (макет Claude Design) -->
    <div v-else class="rstepper">
        <template v-for="(s, i) in stages" :key="s.stage">
            <div class="rstep" :class="{ active: s.stage == this.cur, done: s.stage < this.cur }" v-on:click="this.updateStage(s.stage)">
                <div class="rstep-dot">
                    <svg v-if="s.stage < this.cur" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>
                    <template v-else>{{ s.stage + 1 }}</template>
                </div>
                <div class="rstep-label">{{ s.name }}</div>
            </div>
            <div v-if="i < stages.length - 1" class="rstep-line" :class="{ done: s.stage < this.cur }"></div>
        </template>
    </div>
</template>

<script>
import Button from '@/components/service/Button';

export default {
    components: { Button },
    props: {
        stages: Array,
        stage: [Number, String],
        buttons: [Boolean],
    },
    computed: {
        cur() { return Number(this.stage); },
    },
    methods: {
        updateStage(i) { this.$emit('updateParentState', i); },
    },
};
</script>

<style lang="scss" scoped>
.rstepper { display: flex; align-items: flex-start; margin-bottom: 8px; }
.rstep { display: flex; flex-direction: column; align-items: center; gap: 9px; flex: 0 0 auto; cursor: pointer; }
.rstep-dot {
    width: 34px; height: 34px; border-radius: 50%; border: 2px solid var(--line-strong);
    display: grid; place-items: center; font-weight: 600; font-size: 14px; color: var(--ink-faint);
    background: #fff; transition: all .2s ease;
}
.rstep-dot svg { width: 16px; height: 16px; }
.rstep.active .rstep-dot { border-color: var(--accent); color: var(--accent); box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 14%, transparent); }
.rstep.done .rstep-dot { background: var(--accent); border-color: var(--accent); color: #fff; }
.rstep-label { font-size: 12px; color: var(--ink-faint); white-space: nowrap; }
.rstep.active .rstep-label { color: var(--ink); font-weight: 600; }
.rstep.done .rstep-label { color: var(--ink-soft); }
.rstep-line { flex: 1 1 auto; height: 2px; background: var(--line); align-self: flex-start; margin: 16px 6px 0; border-radius: 2px; transition: background .2s ease; }
.rstep-line.done { background: var(--accent); }
@media (max-width: 540px) { .rstep-label { font-size: 11px; } }
</style>
